import React, { Suspense, useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import { useGlobalStore } from '@robing-org/common-lib'
import { Spin } from 'antd'
import '../../src/App.css'
import { SafetyCertificateOutlined,AlertOutlined,BankOutlined,CalendarOutlined,InboxOutlined,ToolOutlined,ReadOutlined, FacebookFilled    } from '@ant-design/icons'

// ---------------- Lazy Route 封装 ----------------
const LazyRoute = (Component: React.LazyExoticComponent<React.FC<any>>) => (
  <Suspense fallback={
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      background: '#f6f8fa', // 与 AppShell 背景色保持一致
      zIndex: 9999
    }}>
      <div style={{ textAlign: 'center' }}>
        <Spin size="large" />
        <div style={{ 
          marginTop: '16px', 
          color: '#94a3b8', 
          fontSize: '14px',
          fontWeight: 500 
        }}>
          正在加载中...
        </div>
      </div>
    </div>
  }>
    <Component />
  </Suspense>
)

const HomePage = React.lazy(() => import('../pages/base/Home/HomePage'))
const LoginPage = React.lazy(() => import('../pages/base/Login/LoginPage'))
const Message = React.lazy(() => import('../pages/base/Home/Message'))
const PageException = React.lazy(() => import('../pages/base/Exception/PageException'))

const LabPanel = React.lazy(() => import('../pages/labInfo/LabQuery'))
const ViewLabForm = React.lazy(() => import('../pages/labInfo/ViewLabForm'))
const LabAssetCategory = React.lazy(() => import('../pages/instruments/LabAssetCategory'))
const LabsRiskAuditQuery = React.lazy(() => import('../pages/labInfo/LabsRiskAuditQuery'))
const LabIndex = React.lazy(() => import('../pages/labInfo/LabHome'))
const LearnCourseHome = React.lazy(() => import('../pages/learn/LabCourseHome'))
const LearnCategoryList = React.lazy(() => import('../pages/learn/LearnCategoryList'))
const LearnContentDetail = React.lazy(() => import('../pages/learn/LearnContentDetail'))
const MyLearnLessons = React.lazy(() => import('../pages/learn/MyLearnLessons'))
const ExamAnswer = React.lazy(() => import('../pages/learn/exam/ExamAnswer'))
const LearnCategoryVideos = React.lazy(() => import('../pages/learn/LearnCategoryVideos'))
const MyMockExam = React.lazy(() => import('../pages/learn/MyMockExamHistory'))
const MockExam = React.lazy(() => import('../pages/learn/mock/MockExam'))
const MyExamsHistory = React.lazy(() => import('../pages/learn/MyExamsHistory'))


const MonitorHome = React.lazy(() => import('../pages/monitor/MonitorHome'))
const UnboundDevice = React.lazy(() => import('../pages/monitor/UnboundDevice'))
const SessionLogQuery = React.lazy(() => import('../pages/monitor/UsageLogs'))
const MobileMonitorPage = React.lazy(() => import('../pages/monitor/MonitorPage'))

const CertificateVerifyResult = React.lazy(() => import('../pages/learn/CertificateVerifyResult'))
const LabHome = React.lazy(() => import('../pages/learn/LabHome'))
const LabDetail = React.lazy(() => import('../pages/learn/LabDetail'))
const TaskCenter = React.lazy(() => import('../pages/base/Home/TaskCenter'))
const UserCenter = React.lazy(() => import('../pages/base/Home/UserCenter'))


const HazardInspectionHome = React.lazy(() => import('../pages/safety/HazardInspectionHome'))
const InspectionPlanQuery = React.lazy(() => import('../pages/safety/InspectionPlanQuery'))
const InspectionCreate = React.lazy(() => import('../pages/safety/InspectionCreate'))
const MySafetyHazardQuery = React.lazy(() => import('../pages/safety/MySafetyHazardQuery'))
const MySubmitSafetyHazardQuery = React.lazy(() => import('../pages/safety/MySubmitSafetyHazardQuery'))


const MaintenanceHome = React.lazy(() => import('../pages/repair/MaintenanceHome'))
const DeviceRepairQuery = React.lazy(() => import('../pages/repair/DeviceRepairQuery'))
const MobileUpload = React.lazy(() => import('../pages/session/MobileUpload'))

const ConsumableHome = React.lazy(() => import('../pages/cons/ConsumableHome'))
const ConsStockQuery = React.lazy(() => import('../pages/cons/ConsStockQuery'))


// ---------------- 路由配置 ----------------
export const routeConfig = [
  { path: '/home', element: HomePage, meta: { title: '首页', icon: 'HomeOutlined', key: 'home', isMenuVisible: true, order: 1 } },

  {
    path: '/labBase',
    meta: { title: '基础实验室信息', icon: 'BankOutlined', key: 'labBase', isMenuVisible: true, order: 5 },
    children: [
      { path: '/labBase/LabPanel', icon: 'TableOutlined', element: LabPanel, meta: { title: '实验室管理与安全', key: 'labBase.labsPanel', isMenuVisible: true, order: 4 } },
      { path: '/labBase/viewLabForm', icon: 'TableOutlined', element: ViewLabForm, meta: { title: '实验室档案', key: 'labBase.labsQuery', isMenuVisible: false, order: 4 } },
      { path: '/labBase/labsRiskAuditQuery', icon: 'myLearn', element: LabsRiskAuditQuery, meta: { title: '分类分级申请审批', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/labBase/home', icon: 'myLearn', element: LabIndex, meta: { title: '实验室管理', key: 'learn.view', isMenuVisible: true, order: 4 } },
     
      
      { path: '/labBase/instrumentsCategory', icon: 'TableOutlined', element: LabAssetCategory, meta: { title: '实验室档案', key: 'labBase.instruments.category', isMenuVisible: false, order: 4 } },
    
      { path: '/learn/home', icon: 'TableOutlined', element: LearnCourseHome, meta: { title: '安全考试学习', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/learn/category', icon: 'LearnCategoryList', element: LearnCategoryList, meta: { title: '安全考试学习', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/learn/detail/:id', icon: 'LearnContentDetail', element: LearnContentDetail, meta: { title: '安全考试学习', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/learn/myLearn', icon: 'myLearn', element: MyLearnLessons, meta: { title: '安全考试学习', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/learn/exam', icon: 'myLearn', element: ExamAnswer, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/lab/certificateVerify', icon: 'myLearn', element: CertificateVerifyResult, meta: { title: '安全考试证书查询', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/learn/categoryVideos', icon: 'myLearn', element: LearnCategoryVideos, meta: { title: '安全考试学习', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/learn/mockExam', icon: 'TableOutlined', element: MockExam, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/myMockExam', icon: 'TableOutlined', element: MyMockExam, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/myExamsHistory', icon: 'TableOutlined', element: MyExamsHistory, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: false, order: 1 } },
     
      
      { path: '/lab', icon: 'myLearn', element: LabHome, meta: { title: '实验室信息', key: 'learn.view', isMenuVisible: true, order: 4 } },
     
      
      { path: '/lab/labDetail', icon: 'myLearn', element: LabDetail, meta: { title: '实验室信息', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/taskCenter', icon: 'myLearn', element: TaskCenter, meta: { title: '实验室信息', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/userCenter', icon: 'myLearn', element: UserCenter, meta: { title: '用户中心', key: 'learn.view', isMenuVisible: true, order: 4 } },
      { path: '/userMessage', icon: 'myLearn', element: Message, meta: { title: '短消息中心', key: 'learn.view', isMenuVisible: true, order: 4 } },
      
      { path: '/hazardInspection', icon: 'myLearn', element: HazardInspectionHome, meta: { title: '检查计划首页', key: 'safetyInspection.myHazard', isMenuVisible: true, order: 4 } },
      { path: '/safetyInspection/inspectionPlanQuery', icon: 'myLearn', element: InspectionPlanQuery, meta: { title: '检查计划', key: 'safetyInspection.plan', isMenuVisible: true, order: 4 } },
      { path: '/safetyInspection/executing', icon: 'myLearn', element: InspectionCreate, meta: { title: '检查计划', key: 'safetyInspection.plan', isMenuVisible: true, order: 4 } },
      { path: '/safetyInspection/mySafetyHazards', icon: 'myLearn', element: MySafetyHazardQuery, meta: { title: '我负责的隐患', key: 'safetyInspection.myHazard', isMenuVisible: true, order: 4 } },
      { path: '/safetyInspection/mySubmitSafetyHazards', icon: 'myLearn', element: MySubmitSafetyHazardQuery, meta: { title: '我提交的隐患', key: 'safetyInspection.mySubmitRectification', isMenuVisible: true, order: 4 } },
      
      { path: '/maintenance', icon: 'myLearn', element: MaintenanceHome, meta: { title: '保修首页', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
      { path: '/maintenance/deviceRepairQuery', icon: 'myLearn', element: DeviceRepairQuery, meta: { title: '保修首页', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
     
      { path: '/labMonitor', icon: 'myLearn', element: MonitorHome, meta: { title: '实验室终端设备', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
      { path: '/labMonitor/unboundDevice', icon: 'myLearn', element: UnboundDevice, meta: { title: '未绑定实验室终端', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
      { path: '/labMonitor/usageLogs', icon: 'myLearn', element: SessionLogQuery, meta: { title: '实验室终端使用日志', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
      { path: '/labMonitor/monitorPage', icon: 'myLearn', element: MobileMonitorPage, meta: { title: '实验室终端监控', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
      
      { path: '/cons/home', icon: 'myLearn', element: ConsumableHome, meta: { title: '耗材首页', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
      { path: '/cons/stockQuery', icon: 'myLearn', element: ConsStockQuery, meta: { title: '耗材首页', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 4 } },
      
      
    ]
  },

  { path: '/login', element: LoginPage, meta: { title: '登录页', key: 'login', isMenuVisible: false, order: 3 } },
  { path: '/session/Upload', icon: 'myLearn', element: MobileUpload, meta: { title: '移动文件上传', key: 'learn.view', isMenuVisible: true, order: 4 } },
      
  { path: '/403', element: PageException, meta: { title: '403 - 无权限', key: '403', isMenuVisible: false, order: 0 } },
  { path: '/404', element: PageException, meta: { title: '404 - 页面未找到', key: '404', isMenuVisible: false, order: 0 } }
]

// ---------------- 权限过滤器（最终修复版） ----------------
export const filterRoutesWithPermissions = (
  routes: typeof routeConfig,
  permissions: Record<string, string[]>
) => {
  const allowedKeys = Object.values(permissions).flat()

  const filterRecursively = (list: any[]): any[] => {
    return list
      .map(route => {
        // 递归过滤 children
        if (route.children) {
          const filteredChildren = filterRecursively(route.children)
          // children 有任何可访问路由就保留父级
          if (filteredChildren.length > 0) {
            return { ...route, children: filteredChildren }
          }
        }

        // 当前无 element（比如纯目录本身）
        if (!route.element) return null
        // 判断 meta.key 是否在 allowedKeys 中
        if (!route.meta?.key || !allowedKeys.includes(route.meta.key)) return null
        return route
      })
      .filter(Boolean)
  }

  return filterRecursively(routes)
}

// ---------------- 递归生成 Route ----------------
const generateRoutes = (routes: typeof routeConfig, allowedKeys: string[]): React.ReactElement[] =>
  routes.flatMap(route => {
    if (route.children) return generateRoutes(route.children, allowedKeys)

    if (!route.element || !route.meta?.key) return []

    if (!allowedKeys.includes(route.meta.key)) return []

    return (
      <Route
        key={route.path}
        path={route.path}
        element={<PrivateRoute element={LazyRoute(route.element)} />}
      />
    )
  })

// ---------------- RoutesComponent ----------------
const RoutesComponent: React.FC = () => {
  const token = useGlobalStore.getState().token
  const location = useLocation()
  const getUserInfo = useGlobalStore(state => state.getUserInfo)

  const rolePermissions_u = getUserInfo()?.rolePermissions || {}

  const rolePermissions: Record<string, string[]> = {
    ...rolePermissions_u,
    "login": ["login"],
    "404": ["404"],
    "home": ["home"]
  }

  // 扁平化 keys（给 generateRoutes 用）
  const allowedKeys: string[] = Object.values(rolePermissions).flat()

  // 过滤菜单/路由（给前端菜单树 + 路由生成）
  const allowedRouteConfig = filterRoutesWithPermissions(routeConfig, rolePermissions)

  useEffect(() => {
    const route = routeConfig.find(route => route.path === location.pathname)
    if (route?.meta?.title) document.title = route.meta.title
  }, [location])

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />

      {/* 修复登录页死循环 */}
      <Route
        path="/login"
        element={token ? <Navigate to="/home" /> : LazyRoute(LoginPage)}
      />

      {generateRoutes(allowedRouteConfig, allowedKeys)}

      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  )
}

export default RoutesComponent
